<template>
  <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 500px;">
    <van-loading></van-loading>
  </div>
</template>

<script>
import { MallModules } from "@/api/constant";

export default {
  name: "home",

  destroyed() {
    window.removeEventListener('popstate', this.forbidBack, false);
  },

  // 中转页 跳转
  async created() {
    const redirect = this.$route.query.redirect || "/";

    budo_log.debug("#37 created, redirect", redirect)

    let module = MallModules.find((mall) => mall.index === redirect);
    if (!module) {
      module = MallModules.find((mall) => mall.index === '/');
    }

    if (redirect && redirect.split('?').length === 2) {
      const url = redirect.split('?')[0];
      budo_log.info("#35 created redirect", url)

      if (url === '/common-index') {
        const param = redirect.split('?')[1];
        const cateId = param.split('=')[1];
        module = MallModules.find((mall) => mall.topCateId === Number(cateId));
      }

      if (url === '/movie-order-create') {
        module = MallModules.find((mall) => mall.topCateId === 2);
      }
    }

    if (redirect === '/health-index') {
      module = MallModules.find((mall) => mall.topCateId === 8);
    }

    if (redirect === '/travel-index') {
      module = MallModules.find((mall) => mall.topCateId === 7);
    }

    this.$EventBus.$emit("routeInfo", JSON.stringify(module || {}));

    // 跳转到指定页
    this.$router.replace({ path: redirect });
  },

  methods: {
    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    }
  },
};
</script>

<style scoped></style>
